import { macroCondition, isTesting } from '@embroider/macros';

export function focusElement(element: HTMLElement): void {
  if (macroCondition(isTesting())) {
    element.focus({ preventScroll: true });
  } else {
    element.focus();
  }
}
